<div class="detail-truck">
    <div class="title-detail-truck">
        <span class="title-rt">Detail information​</span>
    </div>
    <div class="header-detail-truck">
        <div class="first-item">
            <div class="bold">Plant:</div>
            <div>{{responseDetail?.plant}} - #{{responseDetail?.code}}</div>
            <div class="bold">Date:</div>
            <div>{{responseDetail?.actualStart|ordinalDate}}</div>
        </div>
        <div class="fifty-percent">
            <form [formGroup]="detailTruckForm" (ngSubmit)="UpdateDetailTruck(detailTruckForm.value)">
                <div>
                    <span class="bold">Vehicle</span>
                </div>
                <div class="second-item">
                    <div class="filter">
                        <div class="small-letter">License plate:</div>
                        <div>
                            <input (keyup)="onKeyLP($event)" formControlName="plateNumber" [disabled]="true"
                                class="input-control" type="text" value="{{responseDetail?.platE_NUMBER}}"
                                maxlength="10">
                        </div>
                    </div>
                    <div class="filter">
                        <div class="small-letter">Truck#:​</div>
                        <div>
                            <input (keyup)="onKeyTN($event)" formControlName="truckNumber" [disabled]="_edit" class="input-control" type="text"
                                value="{{responseDetail?.truckNumber}}" maxlength="10">
                        </div>
                    </div>
                    <div class="filter">
                        <div class="small-letter">Company:​</div>
                        <div>
                            <select formControlName="govNumber" #company (change)="changeCompany(company.value)"
                                [disabled]="_edit" class="select-control">
                                <!-- <option value="0" selected></option> -->
                                <option *ngFor="let company of companies" [selected]="company.selected === true"
                                    value="{{company.govNumber}}">
                                    {{company.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="filter">
                        <div class="small-letter">DOT#:​</div>
                        <div>
                            <input (keyup)="onKeyDN($event)" formControlName="dotNumber" id="dotNumber" [disabled]="_edit" class="input-control"
                                type="text" value="{{responseDetail?.dotNumber}}" maxlength="10">
                        </div>
                    </div>
                    <div class="filter">
                        <div class="small-letter">Type:​</div>
                        <div>
                            <select formControlName="attributeValue" #type (change)="changeType(type.value)"
                                [disabled]="_edit" class="select-control">
                                <!-- <option value="0" selected></option> -->
                                <option *ngFor="let av of types" [selected]="av.selected === true" value="{{av.id}}">
                                    {{av.nameEn}}
                                </option>
                            </select>​​
                        </div>
                    </div>
                </div>
                <div class="second-item">
                    <div>
                        <button class="button-control" *ngIf="_edit" (click)="edit()">Edit</button>
                        <button class="button-control" type="submit" *ngIf="!_edit">Save</button>
                    </div>
                </div>
            </form>
        </div>
        <div id="resolution" class="resolution" style="display: none;">
            <!-- <div class="info-msg">
                <i class="fa fa-info-circle"></i>
                This is an info message.
            </div> -->

            <div class="success-msg">
                <i class="fa fa-check"></i>
                Updated successfully.
            </div>

            <!-- <div class="warning-msg">
                <i class="fa fa-warning"></i>
                This is a warning message.
            </div> -->

            <!-- <div class="error-msg">
                <i class="fa fa-times-circle"></i>
                An error occurred.
            </div> -->
        </div>
        <div>
            <div class="first-item">
                <div>Completed trips today:</div>
                <div>{{responseDetail?.amountofjourneys}}</div>
            </div>
            <div class="first-item">
                <div>Avg time of completed trips today:</div>
                <div>{{responseDetail?.avG_TIME}}</div>
            </div>
        </div>
    </div>
    <div class="body-detail-truck">
        <div>
            <div class="tercer-item">
                <span class="bold">Arrival at plant:​</span>
            </div>
            <div class="tercer-item">
                <table class="table-control">
                    <tr>
                        <th>Facility point​​</th>
                        <th>Time</th>
                        <th>Cycle Time​</th>
                        <th>Truck</th>
                        <th>License</th>
                        <th>Truck #</th>
                        <th>DOT</th>
                        <th>Company</th>
                    </tr>
                    <tr *ngFor="let checkPoint of arribalAtPlant">
                        <td>{{checkPoint.steP_NAME}}</td>
                        <td>{{checkPoint.averagE_MINUTES_HHMM}}</td>
                        <td>{{checkPoint.averagE_TIME}}</td>
                        <td>
                            <img neorisBrokenImage (click)="zoom(checkPoint.image_truck)" class="small-image"
                                src="{{checkPoint.image_truck}}" alt="">
                        </td>
                        <td>
                            <img neorisBrokenImage (click)="zoom(checkPoint.image_license)" class="small-image"
                                src="{{checkPoint.image_license}}" alt="">
                        </td>
                        <td>
                            <img neorisBrokenImage (click)="zoom(checkPoint.image_truck_number)" class="small-image"
                                src="{{checkPoint.image_truck_number}}" alt="">
                        </td>
                        <td>
                            <img neorisBrokenImage (click)="zoom(checkPoint.image_dot)" class="small-image"
                                src="{{checkPoint.image_dot}}" alt="">
                        </td>
                        <td>
                            <img neorisBrokenImage (click)="zoom(checkPoint.image_company)" class="small-image"
                                src="{{checkPoint.image_company_data}}" alt="">
                        </td>

                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>

<div id="myModal" class="modal">
    <span (click)="closeModal()" class="close">&times;</span>
    <img class="modal-content" id="img01">
    <div id="caption"></div>
</div>